export const getStreetName = (address: string): string => {
    if (!address) return '';

    const parts = address.split(',').map((p) => p.trim());

    const last = parts.pop() ?? '';

    const words = last.split(' ').filter(Boolean);
    const first = words[0];

    if (!isNaN(Number(first))) {
        words.shift();
    }

    return words.join(' ');
};
